import React, { Component } from 'react';
import Home from './Home';
import privacyPolicy from './Page/privacidad-acuerdo';
import serverPolicy from './Page/servicio-acuerdo';
import ErrorInfo from './Page/ErrorInfo';
import { HashRouter as Router, Route } from "react-router-dom";

class App extends Component {
  render() {
    console.log('----App----')
    return (
      <Router>
        <Route exact path="/" component={Home} />
        <Route exact path="/privacidad-acuerdo" component={privacyPolicy} />
        <Route exact path="/servicio-acuerdo" component={serverPolicy} />
        <Route exact path="/errorInfo" component={ErrorInfo} />
      </Router>
    );
  }
}

export default App;
